import $ from 'jquery';
import 'what-input';
window.jQuery = $;

import './lib/foundation-explicit-pieces';
import {editableSvg, isInViewport, getHiddenOffsetWidth} from './lib/utilities';
import 'slick-carousel/slick/slick';
import magnificPopup from 'magnific-popup';
import './lib/sly.min.js';
import './lib/jquery-ui';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import select2 from 'select2';

import './layout-builder/templates/partner-list';

$(document).foundation();

$(function() {

    /* slick slider */
    $('[data-slick]').slick();

    /* Replace all SVG images with inline SVG */
    editableSvg('img.editable-svg');


    /* Sticky header */
    function stickyHeader() {
      const header = document.querySelector('.site-header');
      const sections = document.querySelectorAll('.content-block:not(.template-art-canvas)');
      const body = document.body,
            html = document.documentElement;
      const docHeight = Math.max( body.scrollHeight, body.offsetHeight, html.scrollHeight, html.offsetHeight );

	  if($('.site-header .brand.cell svg').length) {
		$('.site-header .pill').css('left', $('.site-header .brand.cell svg').offset().left);
      } else {
		$('.site-header .pill').css('left', $('.site-header .brand.cell img').offset().left);
	  }

      function onScrollFunc(){
        let firstSection = $('.hero-unit') || $('.content-block:first-child');
        let offset = 200;

        if(firstSection.length !== 0) {
          offset = firstSection.offset().top + firstSection.innerHeight();
        }

        if (window.pageYOffset > offset) {
          header.classList.add("sticky-shrink");
        } else {
            header.classList.remove("sticky-shrink");
        }

        if(window.pageYOffset >  document.body.scrollHeight / 4) {
          header.classList.add("sticky-pill");

          setTimeout(function(){
            header.classList.add("show-pill");
          }, 600);
        } else {
          header.classList.remove("show-pill");
          setTimeout(function(){
            header.classList.remove("sticky-pill");
          }, 600);
        }
      }

      onScrollFunc();
      // $(window).on('scroll',  function(){
      //   throttle(onScrollFunc, 150)
      // })

      window.addEventListener('wheel', throttle(onScrollFunc, 600), false);
    }

    function throttle(callback, limit) {
      var wait = false;
      return function (...args) {
        if (!wait) {
            callback(...args);
            wait = true;
            setTimeout(function () {
                wait = false;
            }, limit);
        }
      }
    }

    stickyHeader();
    /* end Sticky header */


    /* Hamburger click handle */
    $('.hamburger').on('click', function() {
        $('body').toggleClass('offcanvas-active');
    });

    /* Offcanvas close button handle */
    $('.off-canvas .close-button').on('click', function() {
        $('body').removeClass('offcanvas-active');
    });

    /* icon grid random colors */
	if ($('.template-icon-grid.profile-random').length) {
		$('.template-icon-grid.profile-random').each(function (index, item) {

			let iconGridItems = $(item).find('.item');
			const array = [];
			const result = [], length = 3;
			for (let x = 0; x < iconGridItems.length; x++) array.push(iconGridItems[x]);
			while (array.length) result.push(array.splice(0, length));

			for (let i = 0; i < result.length; i++) {
				for (let n = 0; n < 3; n++) {
					n == 0 ? $(result[i][n]).addClass('profile-pink') : false;
					n == 1 ? $(result[i][n]).addClass('profile-green') : false;
					n == 2 ? $(result[i][n]).addClass('profile-blue') : false;
				}
			}
		})
	}

	/* template card grid */

	if ($('.cards-grid-content .cards-grid .card').length) {
		$('.cards-grid-content').each(function(index, item) {
			let cards = $(item).find('.card');
			let cardsHeight = Math.max($(cards).find('.back').outerHeight());
			$(cards).css('height', cardsHeight + 'px');
		})
	}
	/* template card grid end */

    /* icon grid slider */
    const iconGridSliders = $('.js-icon-grid-slider');


    iconGridSliders.each(function(){
        const slider = $(this);
		const wrap  = slider.parent();
		const desktopScrollbar = slider.parent().find('.desktop-scrollbar');
		const items = slider.find('.item');

		slider.find('.item:first-child').addClass('hover');

		$(window).on('resize', function(){

			if(slider.find('.item.hover').offset().left) {
				const offset = slider.find('.item.hover').offset().left - slider.offset().left;
				desktopScrollbar.find('.handle').stop().animate({
					left: offset
				});
			}
		})

		items.on('mouseover', function(){
			items.removeClass('hover');
			$(this).addClass('hover');
			const offset = $(this).offset().left - slider.offset().left;

			if(offset + desktopScrollbar.find('.handle').innerWidth() >= slider.offset().left + slider.innerWidth()) {
				return;
			}

			desktopScrollbar.find('.handle').stop().animate({
				left: offset
			});
		});

        const options = {
            horizontal: 1,
			itemNav: 'basic',
			smart: 1,
            activateOn: 'click',
			mouseDragging: 1,
			touchDragging: 1,
			releaseSwing: 1,
			startAt: 0,
			scrollBar: wrap.find('.scrollbar'),
			scrollBy: 1,
			speed: 1000,
			elasticBounds: 1,
			dragHandle: 1,
			dynamicHandle: false,
			clickBar: 1,
			cycleBy: 'items',
			cycleInterval: 0,
			pauseOnHover: 1,
			activeClass: 'active',
		}

        const callbackMap = {
            load: function() {
                slider.addClass('initialized');
                calculateSlideWidth();
            }
        }

        const sly = new Sly(slider, options, callbackMap).init();
        sly.reload();

        function calculateSlideWidth() {
            let slidesCount = 4;
            const wrapWidth = wrap.width();

            if($(window).width() < 1024) {
                slidesCount = 3;
            }

            if($(window).width() < 725) {
                slidesCount = 2;
            }

            if($(window).width() < 560) {
                slidesCount = 1;
            }

            const slideWidth = Math.round(wrapWidth / slidesCount);

            slider.find('.item').css({
                'width': slideWidth + 'px',
                'min-width': slideWidth + 'px'
            });
        }

        $(window).on('resize', function(){
            calculateSlideWidth();

            if(sly) {
                sly.reload();
            }
        });
    });

	$('.site-footer demo-popup-btn')

    const iconGridModalSlider = $('.js-modal-icon-grid-slider');

    iconGridModalSlider.each(function(){
        const slider = $(this);
		const wrap  = slider.parent();
        const dots = wrap.find('.modal-slider__dots');

        const options = {
            arrows: false,
            dots: true,
            appendDots: dots,
            fade: true
        }

        slider.on('init', function(event, slick){
            const dotItems = dots.find('li');

            dotItems.each(function(index){
                const itemTitle = slider.find('.item').eq(index).find('.title').text();
                $(this).text(itemTitle);
            });
        });

        slider.slick(options);

        $('.js-icon-grid-modal').on('click',function(){
            const slideId = $(this).attr('data-slide');
            const index = slider.find('.item').index(slider.find('[data-slide="' + slideId + '"]'));
            slider.slick('slickGoTo',index);
        })

    });

	/* icon grid layout carousel */
	if($('.template-icon-grid.layout-up-3 .js-icon-grid-carousel').length) {
		$('.template-icon-grid.layout-up-3 .js-icon-grid-carousel ul').slick({
			arrows: true,
			slidesToScroll: 1,
			slidesToShow: 3,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			]
		})
	}

	if ($('.template-icon-grid:not(.layout-up-3) .js-icon-grid-carousel').length) {
		$('.template-icon-grid:not(.layout-up-3) .js-icon-grid-carousel ul').slick({
			arrows: true,
			slidesToScroll: 1,
			slidesToShow: 2,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				}, {
					breakpoint: 320,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			]
		})
	}
	/* icon grid layout carousel end */

	/* load more */
	function loadMore() {

		let resources = $('.template-resource-archive');
		resources.each(function () {
			let $this = $(this);
			let button = $this.find('.js-resource-archive-more');

			button.on('click', function (e) {
				e.preventDefault();

				const firstCell = $this.find('.cards-wrapper > .cell:hidden')[0];

				if($(window).width() < 1025) {
					$this.find('.cards-wrapper > .cell:hidden').slice(0, 8).slideDown();
				} else {
					$this.find('.cards-wrapper >.cell:hidden').slice(0, 9).slideDown();
				}


				setTimeout(function(){
					if(firstCell) {
						$('html,body').stop().animate({ scrollTop: $(firstCell).offset().top }, 1000);
					}
				}, 200)

				if(!$this.find('.cards-wrapper >.cell:hidden').length) {
					button.fadeOut("slow");
				}

			});
		});

		let logoWall = $('.template-logo-wall');
		logoWall.each(function () {
			let $this = $(this);
			let buttonLogoWall = $this.find('.js-logo-wall-more');

			buttonLogoWall.on('click', function (e) {
				e.preventDefault();
				$this.find('.logo-wall-item:hidden').slice(0, $this.find('.logo-wall-item:hidden').length).slideDown();
				buttonLogoWall.fadeOut("slow");
			});
		});

	}

	loadMore();
	/* load more end */

	/* facetwp radio */

	if ($('.facetwp-type-radio .facetwp-radio').length) {
		$('.facetwp-type-radio .facetwp-radio').click(function () {
			$(this).parent().find('.facetwp-radio').removeClass('checked');
			$(this).addClass('checked');
		})
	}

    if ($('.js-icon-grid-modal').length) {
		$('.js-icon-grid-modal').magnificPopup({
			type: 'inline',
			preloader: false,
			callbacks: {
				open: function () {
					$('.js-modal-icon-grid-slider').slick('setPosition');
				}
			}
		});
	};

    if ($('.demo-popup-btn').length) {
		$('.demo-popup-btn').magnificPopup({
			type: 'inline',
			preloader: false,
		});
	};

	if ($('[href="#demo-popup"]').length) {
		$('[href="#demo-popup"]').magnificPopup({
			type: 'inline',
			preloader: false,
		});
	};

    if ($('.js-team-modal').length) {
		$('.js-team-modal').magnificPopup({
			type: 'inline',
			preloader: false,
		});
	};

	$(".hero-unit-navigation").on('click', 'a[href^="#"]', function (event) {
		event.preventDefault();

		if ($.attr(this, 'href') !== "#" && $.attr(this, 'href') !== "#.html") {
			$('html, body').animate({
				scrollTop: $($.attr(this, 'href')).offset().top,
			}, 1500);
		}
	});

    /* template statistics animation */
	if($('.template-statistics').length) {
		window.onscroll = function() {
			if (isInViewport($('.template-statistics .template-statistics-content'))) {
				let statisticsItems = $('.template-statistics .template-statistics-content .statistics-item');

				for (let i = 0; i < statisticsItems.length; i++) {
					setTimeout(function () {
						$(statisticsItems[i]).css("transform", "translateX(0)");
					},300 * i + 1);
				}
			}
		}
	}
    /* template statistics animation end */

	if ($('.template-content-carousel .press-releases').length) {
		$('.template-content-carousel .press-releases').each(function (index, item) {
			let buttonPressReleases = $(item).find('.js-press-releases-more');
			let itemsReleases = $(item).find('.press-releases-content .row');

			for (let i = 0; i < 4; i ++) {
				$(itemsReleases[i]).addClass('active');
			}

			if(! $(item).find('.press-releases-content .row:not(.active)').length) {
				buttonPressReleases.fadeOut("slow");
			}

			buttonPressReleases.on('click', function (e) {
				e.preventDefault();
				let notActiveItems = $(item).find('.press-releases-content .row:not(.active)').slice(0,4);

				for (let i = 0; i < 4; i++) {
					notActiveItems.addClass('active');
				}

				if(! $(item).find('.press-releases-content .row:not(.active)').length) {
					buttonPressReleases.fadeOut("slow");
				}
			});
		})
	}

	/* template content carousel */

	if ($('.content-carousel-slider').length) {

		$('.content-carousel-slider').each(function(index, item) {

			if( !$(item).hasClass('resource-type') ) {
				let contentCarouselItems = $(item).find('.slider-item');
				const array = [];
				const result = [], length = 3;
				for (let x = 0; x < contentCarouselItems.length; x++) array.push(contentCarouselItems[x]);
				while(array.length) result.push(array.splice(0,length));

				for (let i = 0; i < result.length; i++) {
					for (let n = 0; n < 3; n++) {
						n == 0 ? $(result[i][n]).addClass('profile-pink') : false;
						n == 1 ? $(result[i][n]).addClass('profile-blue') : false;
						n == 2 ? $(result[i][n]).addClass('profile-green') : false;
					}
				}
			}
		})

		$('.content-carousel-slider').slick({
			variableWidth: false,
			infinite: false,
			arrows: true,
			fade: false,
			slidesToScroll: 1,
			slidesToShow: 3,
			nextArrow: '<button type="button" class="slick-next"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 0C20.2435 0 24.3131 1.68571 27.3137 4.68629C30.3143 7.68687 32 11.7565 32 16C32 20.2435 30.3143 24.3131 27.3137 27.3137C24.3131 30.3143 20.2435 32 16 32C11.7565 32 7.68687 30.3143 4.68629 27.3137C1.68571 24.3131 0 20.2435 0 16C0 11.7565 1.68571 7.68687 4.68629 4.68629C7.68687 1.68571 11.7565 0 16 0V0ZM9 15C8.73478 15 8.48043 15.1054 8.29289 15.2929C8.10536 15.4804 8 15.7348 8 16C8 16.2652 8.10536 16.5196 8.29289 16.7071C8.48043 16.8946 8.73478 17 9 17H20.586L16.292 21.292C16.199 21.385 16.1253 21.4954 16.075 21.6168C16.0246 21.7383 15.9987 21.8685 15.9987 22C15.9987 22.1315 16.0246 22.2617 16.075 22.3832C16.1253 22.5046 16.199 22.615 16.292 22.708C16.385 22.801 16.4954 22.8747 16.6168 22.925C16.7383 22.9754 16.8685 23.0013 17 23.0013C17.1315 23.0013 17.2617 22.9754 17.3832 22.925C17.5046 22.8747 17.615 22.801 17.708 22.708L23.708 16.708C23.8011 16.6151 23.875 16.5048 23.9254 16.3833C23.9758 16.2618 24.0018 16.1315 24.0018 16C24.0018 15.8685 23.9758 15.7382 23.9254 15.6167C23.875 15.4952 23.8011 15.3849 23.708 15.292L17.708 9.292C17.5202 9.10423 17.2656 8.99874 17 8.99874C16.7344 8.99874 16.4798 9.10423 16.292 9.292C16.1042 9.47977 15.9987 9.73445 15.9987 10C15.9987 10.2656 16.1042 10.5202 16.292 10.708L20.586 15H9Z" fill="#383838"/></svg></button>',
			prevArrow: '<button type="button" class="slick-prev"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32C20.2435 32 24.3131 30.3143 27.3137 27.3137C30.3143 24.3131 32 20.2435 32 16C32 11.7565 30.3143 7.68687 27.3137 4.68629C24.3131 1.68571 20.2435 0 16 0V0ZM23 15C23.2652 15 23.5196 15.1054 23.7071 15.2929C23.8946 15.4804 24 15.7348 24 16C24 16.2652 23.8946 16.5196 23.7071 16.7071C23.5196 16.8946 23.2652 17 23 17H11.414L15.708 21.292C15.801 21.385 15.8747 21.4954 15.925 21.6168C15.9754 21.7383 16.0013 21.8685 16.0013 22C16.0013 22.1315 15.9754 22.2617 15.925 22.3832C15.8747 22.5046 15.801 22.615 15.708 22.708C15.615 22.801 15.5046 22.8747 15.3832 22.925C15.2617 22.9754 15.1315 23.0013 15 23.0013C14.8685 23.0013 14.7383 22.9754 14.6168 22.925C14.4954 22.8747 14.385 22.801 14.292 22.708L8.292 16.708C8.19887 16.6151 8.12499 16.5048 8.07457 16.3833C8.02416 16.2618 7.99821 16.1315 7.99821 16C7.99821 15.8685 8.02416 15.7382 8.07457 15.6167C8.12499 15.4952 8.19887 15.3849 8.292 15.292L14.292 9.292C14.4798 9.10423 14.7344 8.99874 15 8.99874C15.2656 8.99874 15.5202 9.10423 15.708 9.292C15.8958 9.47977 16.0013 9.73445 16.0013 10C16.0013 10.2656 15.8958 10.5202 15.708 10.708L11.414 15H23Z" fill="#383838"/></svg></button>',
			responsive: [
				{
					breakpoint: 1240,
					settings: {
						slidesToScroll: 1,
						slidesToShow: 2,
					},
				},{
					breakpoint: 920,
					settings: {
						slidesToScroll: 1,
						slidesToShow: 1,
					},
				},{
					breakpoint: 320,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	}
	/* template content carousel end */

	/* js search toggle start */
	if ($('.js-search-toggle').length) {
		$('.site-header .js-search-toggle').on('click', function () {
			$('.primary-navigation .search-wrapper').toggleClass('active');
		})

		$('.site-footer .js-search-toggle').on('click', function (e) {
			e.preventDefault();
			$('.site-footer .search-wrapper').toggleClass('active');
		})

		$('.off-canvas .js-search-toggle a').on('click', function () {
			$('.off-canvas .search-wrapper').toggleClass('active');
		})
	}
	/* js search toggle end */

	/* template cards grid */

	const cardsGridArgs = {
		variableWidth: false,
		infinite: true,
		arrows: true,
		fade: false,
		slidesToScroll: 1,
		slidesToShow: 1,
		centerMode: false,
		mobileFirst: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 1024,
				settings: "unslick"
			},
		],
	}
	$('.cards-grid-content .cards-grid .block-grid').slick(cardsGridArgs);

	function debounce(func, wait, immediate) {
		var timeout;
		return function() {
			var context = this, args = arguments;
			var later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	var slickReinit = debounce(function() {
		if (!$('.cards-grid-content .cards-grid .block-grid').hasClass('slick-initialized') && $(window).width() < 1024) {
			$('.cards-grid-content .cards-grid .block-grid').slick(cardsGridArgs);
			$(window).off('resize.slickReinit');
		}

		$(window).on('resize.slickReinit', slickReinit);
	}, 250);

	slickReinit();
	/* template cards grid end */

	$('.content-carousel-slider').magnificPopup({
		delegate: '.js-events-modal',
		type: 'inline',
		preloader: false
	});

	/* calendar start */
	if ($('.calendar-events-slider').length) {
		const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		$('.calendar-events-slider').slick(
			{
				infinite: false,
				arrows: true,
				slidesToScroll: 1,
				slidesToShow: 1,
				asNavFor: '.calendar-dates-slider',
				nextArrow: '.calendar-slider-next',
				prevArrow: '.calendar-slider-prev',
				swipe: false,
				adaptiveHeight: true,
			}
		);

		$('.calendar-dates-slider').slick(
			{
				infinite: false,
				arrows: false,
				slidesToScroll: 1,
				slidesToShow: 1,
				asNavFor: '.calendar-events-slider',
				swipe: false
			}
		);

		$('.calendar-dates-slider [data-date]').each(function(){
      let currentDate = new Date();
      let slideDate = new Date($(this).attr('data-date'));
      let currentMonth = monthNames[currentDate.getMonth()];
			let currentYear = currentDate.getFullYear();
      let slideMonth = $(this).attr('data-date').split(' ')[0];
      let slideYear = $(this).attr('data-date').split(' ')[1];

      if(currentDate > slideDate) {
        $(this).addClass('prev');
      } else {
        $(this).addClass('next');
      }

      if(currentMonth == slideMonth && currentYear == slideYear) {
        $(this).addClass('current');
      }
    });


		if($('.calendar-events-slider').hasClass('slick-slider')) {
			if($('.calendar-dates-slider .date.current').length === 0) {
				const nextSlide = $('.calendar-dates-slider .date.next')[0];
				const nextSlideIndex = $(nextSlide).closest('.slick-slide').attr('data-slick-index');
				$('.calendar-dates-slider').slick('slickGoTo', nextSlideIndex);
			} else {
				const currentSlide = $('.calendar-dates-slider .date.current')[0];
				const currentSlideIndex = $(currentSlide).closest('.slick-slide').attr('data-slick-index');

				$('.calendar-dates-slider').slick('slickGoTo', currentSlideIndex);
			}
		}

	}
	/* calendar end */

	if ($('.js-events-modal').length) {
		$('.js-events-modal').magnificPopup({
			type: 'inline',
			preloader: false,
		});
	};

	if ($('.content-carousel-slider').length) {
		$('.content-carousel-slider').magnificPopup({
			delegate: '.js-events-modal',
			type: 'inline',
		});
	};

	/* template card grid */
	$('.cards-grid-content .cards-grid .card').click(function(){
		$(this).toggleClass('flipped');
	});
	/* template card grid end */

	/* modal close */
    $(document).on('click', '.modal-close', function (e) {
		$.magnificPopup.close();
	});

	$(document).on('click', function(e) {
		if($(e.target).hasClass('demo-popup')) {
			$.magnificPopup.close();
		}
	});
	/* end modal close */


	 /* ticker */
	 const tickers = $('.js-ticker');

	 $("img").one("load", function() {
		// do stuff
	  }).each(function() {
		if(this.complete) {
			$(this).load(); // For jQuery < 3.0
			// $(this).trigger('load'); // For jQuery >= 3.0
		}
	  });


	 tickers.each(function(){
		let tickerSpeed = 2,
		flickity = null,
		isPaused = false,
		slideshow = $(this),
		slideshowEl = $(this)[0],
		lastX = 0,
		animationId = null,
		isResized = false,
		loaded = false;

		function setSlideWidth() {
			slideshow.find('.item').each(function(){

				if($(this).innerWidth() == 0) {
					loaded = false;
					setTimeout(function(){
						setSlideWidth();
					}, 500);
					return;
				} else {
					$(this).css('width', $(this).innerWidth());
					$(this).attr('data-width', $(this).innerWidth());
				}
			});

			loaded = true;
		}

		setSlideWidth();

		slideshow.attr('data-original-slides', slideshow.find('.item').length);

		 function _ticker() {
			 let 	itemsCount = parseInt($(slideshowEl).attr('data-original-slides')),
				 	windowWidth = $(window).width(),
					totalWidth = 0;

				 $(slideshowEl).find('.item').each(function(index){
					totalWidth += parseInt($(this).attr('data-width')) +  parseInt($(this).css('margin-right')) * 2;
				 });


			 const tickerUpdate = () => {
				 if (isPaused) return;
				 if (flickity && flickity.slides) {

					 if(flickity.x == 0) {
						 flickity.x = lastX;
					 }

					 flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
					 flickity.selectedIndex = flickity.dragEndRestingSelect();
					 flickity.updateSelectedSlide();
					 flickity.settle(flickity.x);
					 lastX = flickity.x;
				 }


				 animationId = window.requestAnimationFrame(tickerUpdate);
			   };

			 const tickerPause = () => {
				 window.cancelAnimationFrame(animationId);
				 isPaused = true;
			 };

			 const tickerPlay = () => {

				 if (isPaused) {
					 isPaused = false;
					 animationId = window.requestAnimationFrame(tickerUpdate);
				 }
			 };

			 const startTicker = () => {
				 if(itemsCount == 1) return;

				 $(slideshowEl).removeClass('carousel-disabled');

				 flickity = new Flickity(slideshowEl, {
					 cellAlign: 'left',
					 autoPlay: false,
					 prevNextButtons: true,
					 pageDots: false,
					 draggable: true,
					 wrapAround: true,
					 selectedAttraction: 0.015,
					 friction: 0.15,
					 imagesLoaded: true
				 });

				 $(window).load( function() {
					 flickity.resize();
				 });

				 flickity.x = 0;

				 slideshowEl.addEventListener('mouseenter', tickerPause, false);
				 slideshowEl.addEventListener('focusin', tickerPause, false);
				 slideshowEl.addEventListener('mouseleave', tickerPlay, false);

				 flickity.on('dragStart', () => {
					 isPaused = true;
				 });

				 tickerUpdate();
			 }

			 const destroyTicker = () => {
				 window.cancelAnimationFrame(animationId);
				 slideshowEl.removeEventListener('mouseenter', tickerPause);
				 slideshowEl.removeEventListener('focusin', tickerPause);
				 slideshowEl.removeEventListener('mouseleave', tickerPlay);
				//slideshowEl.removeEventListener('focusout', tickerPlay);
				 flickity.destroy();
				 flickity = null;
				 $(slideshowEl).addClass('carousel-disabled');
			 }

			 if (windowWidth > totalWidth) {
				 if (flickity) {
					 destroyTicker();
				 }
			 } else {
				 if (flickity == null) {
					 startTicker();
				 }
			 }
		 }

		 if(loaded) {
			_ticker();
			$(window).on('resize', _ticker);
		 }

	 });
	 /* end ticker */


	 $('.popup-video').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
		iframe: {
			markup: '<div class="mfp-iframe-scaler">'+
					  '<div class="mfp-close"></div>'+
					  '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
					'</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

			patterns: {
			  youtube: {
				index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

				id: 'v=', // String that splits URL in a two parts, second part should be %id%
				// Or null - full URL will be returned
				// Or a function that should return %id%, for example:
				// id: function(url) { return 'parsed id'; }

				src: '//www.youtube.com/embed/%id%?rel=0&autoplay=1' // URL that will be set as a source for iframe.
			  },
			  vimeo: {
				index: 'vimeo.com/',
				id: '/',
				src: '//player.vimeo.com/video/%id%?autoplay=1'
			  },
			  gmaps: {
				index: '//maps.google.',
				src: '%id%&output=embed'
			  }
			},

			srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
		  }
	});

	$('.popup-image').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		mainClass: 'mfp-fade',
		image: {
			verticalFit: true
		}
	});

	/* resources slider */
	function resourcesSlider(){
		var $frame  = $('.filter-slider');
		var $slidee = $frame.children('.facetwp-radio').eq(0);
		var $wrap   = $frame.parent();

		// Call Sly on frame
		$frame.sly({
			horizontal: 1,
			itemNav: 'basic',
			smart: 1,
			activateOn: 'click',
			mouseDragging: 1,
			touchDragging: 1,
			releaseSwing: 1,
			scrollBy: 1,
			activatePageOn: 'click',
			speed: 300,

			// Buttons
			prevPage: $wrap.find('.prev'),
			nextPage: $wrap.find('.next'),
		});
	}

	document.addEventListener('facetwp-loaded', function() {
		resourcesSlider();
		loadMore();
     });


	function setVw() {
	let vw = document.documentElement.clientWidth / 100;
	document.documentElement.style.setProperty('--vw', `${vw}px`);
	}

	setVw();
	window.addEventListener('resize', setVw);

	let current_language = $('html').attr('lang');

	if(current_language=='en' || current_language=='en-US' || !current_language) {
		$('#gtranslate_selector option[value="en|en"]').prop('selected', true);
	} else {
		$('#gtranslate_selector option[value*="|'+ current_language +'"]').prop('selected', true);
	}

	$('#gtranslate_selector').select2({
		minimumResultsForSearch: -1
	})

	// $(document).ready(function() {
	// 	let currentOption = $(".switcher div.option a[onclick*='|"+$('html').attr('lang')+"']");
	// 	if(currentOption) {
	// 		$('.switcher .option a').removeClass('selected');
	// 		currentOption.addClass('selected');
	// 	}
	// });


	$(function(){
		const pageLang = document.documentElement.lang.toLowerCase();
		$('.language-picker').each(function(){
			$(this).val(pageLang)
		})
	})

	$(document).on('change', '.language-picker', function(){
		const path = window.location.pathname;
		const query = window.location.search;
		const hash = window.location.hash;
		const desiredLangCode = $(this).val()
		const newSubDomain = desiredLangCode === 'en-us' ? 'www' : desiredLangCode
		//localStorage.setItem('desiredLangCode', desiredLangCode);
		window.location.href = `https://${newSubDomain}.daon.com${path}${query}${hash}`;
	});

	// $('a').click(function(e) {
	// 	if((e.target.href.includes('daon.com') !== true) && (e.target.href.includes('javascript') !== true)){
	// 		$(this).attr('target', '_blank');
	// 	}
	//
	// });

	const sites = ["localhost", "daon.com","www.daon.com", "daon.imagemakersdev.com", "daonstaging.wpengine.com", "daondev.wpengine.com"];
	$('a').click(function(e) {
		var host = new URL(e.target.href).host;
		if((sites.includes(host) !== true) && (e.target.href.includes('javascript') !== true)){
			$(this).attr('target', '_blank');
		}

	});

	$(document).ready(function() {
		$('a[target="_blank"]').each(function() {
			var href = $(this).attr('href');
			if (href && !href.includes('javascript')) {
				$(this).attr('rel', 'noreferrer noopener');
			}
		});
	});

	var linkel = document.querySelector(".menu-do-not-sell-or-share");
	var link = linkel.querySelector('a');
	link.setAttribute("href", "javascript:void(0);");
	link.setAttribute("id", "linkug");
	$('#linkug').on('click', function (e) {
		e.preventDefault();
		var cookieel = document.querySelector(".ot-floating-button__open");
		cookieel.click();

	})


});
